import {Entity} from 'app/core/main.entity';

export class Permissions extends Entity {
  permissions: string[];

  constructor(permissions: string[]) {
    super();

    this.permissions = permissions;
  }

  checkPermission(permission: string) {
    return this.permissions.includes(permission);
  }
}
